"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuery = void 0;
var _client = require("@apollo/client");
var _react = require("@apollo/client/react");
var _react2 = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useQuery = (query, options) => {
  var _useBaseQuery = (0, _react.useQuery)(query, _objectSpread({
      notifyOnNetworkStatusChange: true
    }, options)),
    data = _useBaseQuery.data,
    previous = _useBaseQuery.previousData,
    loading = _useBaseQuery.loading,
    networkStatus = _useBaseQuery.networkStatus,
    error = _useBaseQuery.error,
    refetch = _useBaseQuery.refetch,
    fetchMore = _useBaseQuery.fetchMore,
    client = _useBaseQuery.client;
  var _useMemo = (0, _react2.useMemo)(() => {
      return {
        isLoading: loading,
        refetching: networkStatus === _client.NetworkStatus.refetch
      };
    }, [loading, networkStatus]),
    isLoading = _useMemo.isLoading,
    refetching = _useMemo.refetching;
  return {
    data,
    previous,
    loading: isLoading,
    refetch,
    refetching,
    fetchMore,
    error,
    client
  };
};
exports.useQuery = useQuery;